import React from 'react';
import styles from './index.module.scss';
import BlockA from '../../_block_components/block_a';
import BlockB from '../../_block_components/block_b';
import ContactsBlock from '../../other_components/callback_btn/contacts_block';
import ContactsSliderBlock from '../../_block_components/contacts_slider_block';
import ContactsAdressBlock from '../../_block_components/contacts_adress_block';
import UnknownBlock from '../../_block_components/unknown_block';

const ContactsV1 = ({ publication, globalIndex }) => {
  const [publicationData, setPublicationData] = React.useState(null);
  const [contentData, setContentData] = React.useState(null);
  const [path_to_folder, setPath_to_folder] = React.useState(null);

  React.useEffect(() => {
    if (publication) {
      setPublicationData(publication);
    }
  }, [publication]);

  React.useEffect(() => {
    if (publicationData) {
      // Парсим content
      if (publicationData.content) {
        try {
          const parsedContent = JSON.parse(publicationData.content);
          setContentData(parsedContent);
        } catch (error) {
          setContentData(null);
        }
      }

      // Создаем path_to_folder
      if (publicationData.path && publicationData.eng_name) {
        const pathValue = `https://${publicationData.path}${publicationData.eng_name}/`;
        setPath_to_folder(pathValue);
      }
    }
  }, [publicationData]);

  // Извлекаем заголовок из блока с тегом header_block
  const title = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData)) return null;

    const headerBlock = contentData.find((block) => (block.boock_tag === 'header_block' || block.block_tag === 'header_block'));
    if (!headerBlock || !headerBlock.block_content || !Array.isArray(headerBlock.block_content)) {
      return null;
    }

    // Ищем текстовый контент в блоке
    const textContent = headerBlock.block_content.find(
      (content) => (content.cotent_type === 'text' || content.content_type === 'text') || (content.cotent_type === 'long_text' || content.content_type === 'long_text'),
    );

    return textContent?.content_text || null;
  }, [contentData]);

  // ================================================
  // ПРЕДФИЛЬТРАЦИЯ: Убираем пустые и header блоки
  // ================================================
  const filteredBlocks = React.useMemo(() => {
    if (!contentData || !Array.isArray(contentData)) {
      return [];
    }

    return contentData.filter((blockData) => {
      // Пропускаем header_block (используется для заголовка)
      if (blockData && (blockData.boock_tag === 'header_block' || blockData.block_tag === 'header_block')) {
        return false;
      }

      // Пропускаем блоки без данных
      if (!blockData || !(blockData.boock_tag || blockData.block_tag)) {
        return false;
      }

      // Пропускаем блоки с пустым block_content
      if (
        !blockData.block_content ||
        !Array.isArray(blockData.block_content) ||
        blockData.block_content.length === 0
      ) {
        return false;
      }

      // Оставляем блок
      return true;
    });
  }, [contentData]);

  // ================================================
  // ГРУППИРОВКА БЛОКОВ: До и после карты (slider_block)
  // ================================================
  const { blocksBeforeMap, mapBlock, blocksAfterMap } = React.useMemo(() => {
    const mapIndex = filteredBlocks.findIndex((block) => (block.boock_tag === 'slider_block' || block.block_tag === 'slider_block'));

    if (mapIndex !== -1) {
      return {
        blocksBeforeMap: filteredBlocks.slice(0, mapIndex),
        mapBlock: filteredBlocks[mapIndex],
        blocksAfterMap: filteredBlocks.slice(mapIndex + 1),
      };
    }

    // Если карты нет, весь контент идет в "до карты"
    return {
      blocksBeforeMap: filteredBlocks,
      mapBlock: null,
      blocksAfterMap: [],
    };
  }, [filteredBlocks]);

  const renderBlock = (blockData, index) => {
    if (!blockData || !(blockData.boock_tag || blockData.block_tag)) {
      return <UnknownBlock key={index} blockData={blockData} path_to_folder={path_to_folder} />;
    }

    switch (blockData.boock_tag || blockData.block_tag) {
      case 'block_a':
        return (
          <BlockA
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'block_b':
        return (
          <BlockB
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'contacts_block':
        return (
          <ContactsBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'slider_block':
        return (
          <ContactsSliderBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      case 'adress_block':
        return (
          <ContactsAdressBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
      default:
        return (
          <UnknownBlock
            key={index}
            blockData={blockData}
            path_to_folder={path_to_folder}
            blockIndex={index}
          />
        );
    }
  };

  return (
    <div className={styles.contactsV1}>
      <div className={styles.container}>
        {title && (
          <div className={styles.header}>
            <h1 className={styles.title}>{title}</h1>
          </div>
        )}

        {filteredBlocks.length > 0 ? (
          <div className={styles.blocksContainer}>
            {/* Блоки ДО карты */}
            {blocksBeforeMap.length > 0 && (
              <div className={styles.groupContainer}>
                {blocksBeforeMap.map((block, index) => renderBlock(block, index))}
              </div>
            )}

            {/* Карта */}
            {mapBlock && renderBlock(mapBlock, filteredBlocks.indexOf(mapBlock))}

            {/* Блоки ПОСЛЕ карты */}
            {blocksAfterMap.length > 0 && (
              <div className={styles.groupContainer}>
                {blocksAfterMap.map((block, index) =>
                  renderBlock(block, filteredBlocks.indexOf(block)),
                )}
              </div>
            )}
          </div>
        ) : (
          <div className={styles.noContent}>
            <p>Контактная информация не найдена</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactsV1;
